export default dataArray => {
  const requiredFields = ['title', 'description', 'image', 'postDate'];

  const error = dataArray
    .map(item => {
      const populatedFields = requiredFields.filter(
        field =>
          item[field] !== null &&
          item[field] !== undefined &&
          item[field] !== ''
      );

      // If some but not all fields are populated
      if (
        populatedFields.length > 0 &&
        populatedFields.length < requiredFields.length
      ) {
        const missingFields = requiredFields.filter(
          field => !item[field] || item[field] === ''
        );
        return `Error: Not all mandatory fields for ${
          item.language
        } are populated. Missing: ${missingFields.join(', ')}`;
      }

      return null;
    })
    .find(e => e !== null);

  return error || null;
};
